const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/counting-configurations`,
    saveSpeedTable: `${API_URL}/counting-configuration/save-speed-table`
};

export default apiUrls;
